import React, { Component } from 'react';
import { connect } from 'react-redux'
import classnames from 'classnames'
import '@/assets/styles/components/order-fees-dialog.scss';
import { formatFunctions } from '@/helpers/functions';
import { dataType } from '@/constants/data-type'
class OrderFeesDialog extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    getorderFees = () => {
        const {language, feesList, currencyID, feeAmt} = this.props; 
        let orderFeesDetailed = [];
        feesList.map((item,index) => {
            const languageKey = `common_${item.feeName.toLowerCase().replaceAll(' ','_')}`
            orderFeesDetailed.push(
                <div className={classnames('order-fees-detailed')} key={index}>
                    <span>{language[languageKey] ? language[languageKey] : item.feeName}</span>
                    <span>{currencyID}&nbsp;{formatFunctions.dataFormat(item.amount,dataType.CASH)}</span>
                </div>
            )
        })
        orderFeesDetailed.push(
            <div className={classnames('order-fees-detailed')} key={feesList.length}>
                <span>{language.common_fees_total_amount}</span>
                <span>{currencyID}&nbsp;{formatFunctions.dataFormat(feeAmt,dataType.CASH)}</span>
            </div>
        )
        return orderFeesDetailed;
    }

    render() {
        return (
            <div className={classnames('order-fees')}>
                <div className={classnames('order-fees-content')}>
                    {this.getorderFees()}
                </div>
            </div>
        );
    }
}
 
export default connect(
    state => ({
      language: state.app.language,
      isMobile: state.app.isMobile,
      currentTradingAccount: state.trade.currentTradingAccount
    }),
    dispatch => ({

    })
  )(OrderFeesDialog)